/* Elk Head Clothing theme JS — small, dependency-free. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Header bag count, after an Ajax add
  const showBagCount = n => { let count = $('.bag-count'); if (!count) { count = document.createElement('span'); count.className = 'bag-count'; $('.utils a[aria-label=Bag]')?.appendChild(count); } count.textContent = n; };

  // Mobile nav
  $$('[data-open-nav]').forEach(b => b.addEventListener('click', () => $('[data-mobile-nav]').classList.add('open')));
  $$('[data-close-nav]').forEach(b => b.addEventListener('click', () => $('[data-mobile-nav]').classList.remove('open')));

  // Hero carousel
  $$('[data-hero]').forEach(hero => {
    const slides = $$('.slide', hero), dots = $('.dots', hero);
    if (slides.length < 2) { $('.hero-nav', hero)?.remove(); return; }
    let cur = 0, timer;
    slides.forEach((_, i) => { const b = document.createElement('button'); b.className = 'dot' + (i ? '' : ' active'); b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); b.onclick = () => go(i, true); dots.appendChild(b); });
    const go = (i, user) => { cur = (i + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('active', k === cur)); [...dots.children].forEach((d, k) => d.classList.toggle('active', k === cur)); if (user) restart(); };
    const restart = () => { clearInterval(timer); if (!reduced && hero.dataset.autoplay !== 'false') timer = setInterval(() => go(cur + 1), Number(hero.dataset.interval || 6500)); };
    $('[data-prev]', hero).onclick = () => go(cur - 1, true); $('[data-next]', hero).onclick = () => go(cur + 1, true);
    hero.addEventListener('mouseenter', () => clearInterval(timer)); hero.addEventListener('mouseleave', restart); restart();
  });

  // Shop tabs + rail arrows
  $$('[data-tabs]').forEach(tabs => {
    $$('.tab', tabs).forEach(t => t.addEventListener('click', () => {
      $$('.tab', tabs).forEach(x => x.classList.toggle('active', x === t));
      $$('.panel', tabs).forEach(p => p.classList.toggle('active', p.dataset.panel === t.dataset.tab));
    }));
    $$('.railnav .arrow', tabs).forEach(a => a.addEventListener('click', () => {
      const rail = $('.panel.active .rail', tabs), card = $('.card', rail);
      rail.scrollBy({ left: (card.offsetWidth + 24) * 3 * Number(a.dataset.dir), behavior: 'smooth' });
    }));
  });

  // Scroller sections (signature details): arrows move one card at a time
  $$('[data-scroller]').forEach(sec => {
    const track = $('[data-scroll-track]', sec);
    $$('.railnav .arrow', sec).forEach(a => a.addEventListener('click', () => {
      const card = track && track.firstElementChild;
      if (!card) return;
      const step = card.offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 24);
      track.scrollBy({ left: step * Number(a.dataset.dir), behavior: reduced ? 'auto' : 'smooth' });
    }));
  });

  // Hotspots
  $$('[data-hotspots]').forEach(sec => {
    const spots = $$('.spot', sec), items = $$('.dl li', sec), linked = $$('[data-n]', sec);
    const activate = n => linked.forEach(el => el.classList.toggle('active', el.dataset.n === n));
    [...spots, ...items].forEach(el => ['mouseenter', 'click', 'focus'].forEach(ev => el.addEventListener(ev, () => activate(el.dataset.n))));
    if (spots[0]) activate(spots[0].dataset.n);
  });

  // Inspiration board: random six from the pool
  $$('[data-board]').forEach(board => {
    const pool = JSON.parse(board.dataset.board || '[]');
    pool.sort(() => Math.random() - .5).slice(0, Number(board.dataset.count || 6)).forEach(src => {
      const a = document.createElement('a'); a.href = board.dataset.href || '#';
      a.innerHTML = `<img src="${src}" alt="" loading="lazy"><div class="ov"><span>${board.dataset.label || 'From the board'}</span></div>`;
      board.appendChild(a);
    });
  });

  // Quick add from cards (Ajax cart)
  $$('[data-quick-add]').forEach(b => b.addEventListener('click', async e => {
    e.preventDefault(); e.stopPropagation();
    b.textContent = '…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.quickAdd), quantity: 1 }) });
      if (!r.ok) throw new Error();
      b.textContent = '✓';
      const c = await (await fetch('/cart.js')).json();
      showBagCount(c.item_count);
    } catch { b.textContent = '!'; }
  }));

  // Collection: mobile filter drawer + sort submit
  $$('[data-filter-toggle]').forEach(b => b.addEventListener('click', () => $('#filters').classList.toggle('open')));
  const filters = $('#filters'); if (filters) filters.addEventListener('click', e => { if (e.target === filters) filters.classList.remove('open'); });
  $$('[data-auto-submit]').forEach(el => el.addEventListener('change', () => el.form.submit()));

  // Product: variant picker, stock notes, quantity, sticky bar
  const pform = $('[data-product-form]');
  if (pform) {
    const variants = JSON.parse($('[data-variants]').textContent);
    const idInput = $('input[name=id]', pform), note = $('#stocknote'), add = $('#add'), bar = $('#stickybar'), barSel = $('#bar-size'), qty = $('#qty');
    const price = $('[data-price]');
    const pick = b => {
      if (b.classList.contains('out')) return;
      $$('.sizes button', pform).forEach(x => x.classList.toggle('active', x === b));
      const v = variants.find(v => String(v.id) === b.dataset.id); if (!v) return;
      idInput.value = v.id; if (barSel) barSel.value = v.id;
      const left = v.inventory_quantity;
      note.innerHTML = v.inventory_management && left <= 3 && left > 0 ? `<b>Only ${left} left</b> in ${v.title}.` : 'In stock. Ships from Atlanta in 1 to 2 business days.';
      add.disabled = false; add.textContent = add.dataset.label || 'Add to bag';
      if (price) price.textContent = v.price_formatted;
      history.replaceState(null, '', `?variant=${v.id}`);
    };
    $$('.sizes button', pform).forEach(b => b.addEventListener('click', e => { e.preventDefault(); pick(b); }));
    if (barSel) barSel.addEventListener('change', () => { const b = $$('.sizes button', pform).find(x => x.dataset.id === barSel.value); if (b) pick(b); });
    $$('.qty button').forEach(b => b.addEventListener('click', e => { e.preventDefault(); qty.value = Math.max(1, Number(qty.value) + Number(b.dataset.d)); }));
    const barAdd = $('#bar-add'); if (barAdd) barAdd.addEventListener('click', () => { if (!idInput.value) { note.innerHTML = '<b>Choose a size</b> to add this to your bag.'; return; } pform.requestSubmit(); });
    if (bar) new IntersectionObserver(([e]) => bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0)).observe($('.cta', pform));
    pform.addEventListener('submit', async e => {
      if (!idInput.value) { e.preventDefault(); note.innerHTML = '<b>Choose a size</b> to add this to your bag.'; return; }
      e.preventDefault();
      add.textContent = 'Adding…';
      const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(pform) });
      if (r.ok) { add.textContent = 'Added ✓'; const c = await (await fetch('/cart.js')).json(); showBagCount(c.item_count); setTimeout(() => add.textContent = add.dataset.label || 'Add to bag', 1600); }
      else { add.textContent = 'Could not add'; }
    });
  }

  // Landing page: photo slider, size picker and add-to-bag on each featured product, and a
  // checkout bar once the bag has something in it.
  $$('[data-lp-slider]').forEach(sl => {
    const track = $('.lp-track', sl), slides = [...track.children], thumbs = $$('.lp-thumbs button', sl);
    if (slides.length < 2) { $('.lp-thumbs', sl)?.remove(); return; }
    const step = () => slides[1].offsetLeft - slides[0].offsetLeft;
    thumbs.forEach((t, i) => t.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: reduced ? 'auto' : 'smooth' })));
    track.addEventListener('scroll', () => { const at = Math.round(track.scrollLeft / step()); thumbs.forEach((t, i) => t.classList.toggle('active', i === at)); }, { passive: true });
  });
  const lpBag = $('[data-lp-bag]');
  let lpCount = Number(lpBag?.dataset.count || 0), lpPast = false;
  const showLpBag = () => lpBag.classList.toggle('show', lpCount > 0 && lpPast);
  const money = (cents, currency) => new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  const setLpBag = c => {
    if (!lpBag) return;
    lpCount = c.item_count;
    $('[data-lp-bag-count]', lpBag).textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items');
    $('[data-lp-bag-total]', lpBag).textContent = money(c.total_price, c.currency);
    showLpBag();
  };
  // Like the product page's sticky bar, it only shows once the header has scrolled away.
  if (lpBag && $('.header')) new IntersectionObserver(([e]) => { lpPast = !e.isIntersecting && e.boundingClientRect.top < 0; showLpBag(); }).observe($('.header'));
  $$('[data-lp-form]').forEach(form => {
    const idInput = $('input[name=id]', form), note = $('.stocknote', form), add = $('.lp-add', form), sizes = $$('.sizes button', form);
    const price = $('[data-price]', form.closest('.lprod'));
    sizes.forEach(b => b.addEventListener('click', () => {
      if (b.classList.contains('out')) return;
      sizes.forEach(x => x.classList.toggle('active', x === b));
      idInput.value = b.dataset.id;
      note.innerHTML = b.dataset.left > 0 ? `<b>Only ${b.dataset.left} left</b> in ${b.textContent}.` : 'In stock. Ships from Atlanta in 1 to 2 business days.';
      add.textContent = add.dataset.label;
      if (price) price.textContent = b.dataset.price;
    }));
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!idInput.value) { note.innerHTML = `<b>Choose a ${form.dataset.option || 'size'}</b> to add this to your bag.`; return; }
      add.disabled = true; add.textContent = 'Adding…';
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Could not add that. Try again.');
        add.textContent = 'Added ✓'; note.innerHTML = '<b>Added to your bag.</b>';
        const c = await (await fetch('/cart.js')).json();
        showBagCount(c.item_count); setLpBag(c);
      } catch (err) { add.textContent = add.dataset.label; note.textContent = err.message; }
      setTimeout(() => { add.disabled = false; add.textContent = add.dataset.label; }, 1600);
    });
  });

  // Size guide: one chart per product (see snippets/size-chart.liquid). Opens in a dialog,
  // switches inches/cm and highlights the size already picked.
  const inches = t => { const m = String(t).trim().match(/^(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?$/); return m ? Number(m[1]) + (m[2] ? m[2] / m[3] : 0) : null; };
  const setUnits = (chart, unit) => {
    $$('.sc-units button', chart).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.unit === unit)));
    const name = $('[data-unit-name]', chart); if (name) name.textContent = unit === 'cm' ? 'centimeters' : 'inches';
    $$('td[data-v]', chart).forEach(td => {
      if (!td.dataset.inch) td.dataset.inch = td.innerHTML;
      const v = inches(td.dataset.v);
      td.innerHTML = unit === 'cm' && v !== null ? String(Math.round(v * 2.54 * 2) / 2) : td.dataset.inch;
    });
  };
  const markSize = guide => {
    const picked = ($('.sizes button.active')?.textContent || '').trim().toUpperCase();
    $$('.sc-table', guide).forEach(t => {
      const col = $$('thead th, thead td', t).findIndex(c => c.textContent.trim().toUpperCase() === picked);
      $$('tr', t).forEach(tr => [...tr.children].forEach((c, i) => c.classList.toggle('on', col > 0 && i === col)));
    });
  };
  document.addEventListener('click', e => {
    const unit = e.target.closest('.sc-units button'); if (unit) setUnits(unit.closest('[data-size-chart]'), unit.dataset.unit);
    const open = e.target.closest('[data-size-guide]'); const guide = $('#sizeguide');
    if (open && guide) { e.preventDefault(); markSize(guide); guide.showModal(); }
    if (e.target.closest('.sg-close') || e.target.matches('dialog.sizeguide')) e.target.closest('dialog')?.close();
    const more = e.target.closest('.qmore'); if (more) { const card = more.closest('.ycard'); const open = card.classList.toggle('open'); more.textContent = open ? 'Show less' : 'Read more'; more.setAttribute('aria-expanded', String(open)); }
  });
})();
